import { render } from "./csstmManage.vue?vue&type=template&id=0a341b4a"
import script from "./csstmManage.vue?vue&type=script&lang=js"
export * from "./csstmManage.vue?vue&type=script&lang=js"

import "./csstmManage.vue?vue&type=style&index=0&id=0a341b4a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__